// hooks/useDashboardApi.js
import { useQuery } from '@tanstack/react-query';
import { getDashboardAnalytics } from '../lib/dashboardApi';

export const useGetDashboardAnalytics = () => {
  return useQuery({
    queryKey: ['dashboardAnalytics'], // A unique key for this data
    queryFn: getDashboardAnalytics,
  });
};